import type * as Types from '../../../../graphql/base-types.graphql';

import { gql } from '@apollo/client';
import { SibmFieldsFragmentDoc } from '../../../../graphql/gql-fragments/share-issue-board-member.graphql';
import { SiFieldsFragmentDoc } from '../../../../graphql/gql-fragments/share-issue.graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GqlCreateShareIssueBoardMemberMutationVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  input: Types.GqlSibmCreateInput;
}>;


export type GqlCreateShareIssueBoardMemberMutation = { createShareIssueBoardMember: { id: string, shareIssueId: string, identityId: string, createdAt: string, updatedAt: string } };

export type GqlDeleteShareIssueBoardMemberMutationVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  id: Types.Scalars['ID']['input'];
}>;


export type GqlDeleteShareIssueBoardMemberMutation = { deleteShareIssueBoardMember: { id: string } };

export type GqlSiSetBoardsStatementMutationVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  input: Types.GqlSiSetBoardsStatementInput;
}>;


export type GqlSiSetBoardsStatementMutation = { siSetBoardStatement: { shareIssue: { approvedByMeeting?: boolean | null, boardsStatementDate?: string | null, boardsStatementEn?: string | null, boardsStatementOption?: Types.GqlBoardsStatementOption | null, boardsStatementSv?: string | null, companyId: string, createdAt: string, description: string, id: string, maxNumberOfShares?: string | null, minNumberOfShares?: string | null, nonCashStatementPl?: string | null, nonCashStatementSl?: string | null, numberOfSharesBefore?: string | null, paidForAt?: string | null, paymentKindCash: boolean, paymentKindNonCash: boolean, paymentKindOffset: boolean, preferentialRights: boolean, pricePerShare?: string | null, maxPaidAmount?: string | null, currency: Types.GqlCurrency, primaryLang: boolean, published?: boolean | null, quotaValue?: string | null, restrictedToParticipants?: boolean | null, secondaryLang: boolean, snrAuthorizationId?: string | null, snrShareCapitalChangeId?: string | null, stripeInvoiceId?: string | null, subscriptionEndDate?: string | null, subscriptionStartDate?: string | null, updatedAt: string, purpose: Types.GqlShareIssuePurpose, decisionKind?: Types.GqlDecisionKind | null, paymentCount: { paid: number, waiting: number, notPaid: number }, shareClasses: Array<{ name: string, voteWeight: string, quantity?: string | null, min: string, max: string }> } } };


export const CreateShareIssueBoardMemberDocument = gql`
    mutation CreateShareIssueBoardMember($companyId: ID!, $input: SibmCreateInput!) {
  createShareIssueBoardMember(companyId: $companyId, input: $input) {
    ...SibmFields
  }
}
    ${SibmFieldsFragmentDoc}`;
export type GqlCreateShareIssueBoardMemberMutationFn = Apollo.MutationFunction<GqlCreateShareIssueBoardMemberMutation, GqlCreateShareIssueBoardMemberMutationVariables>;

/**
 * __useCreateShareIssueBoardMemberMutation__
 *
 * To run a mutation, you first call `useCreateShareIssueBoardMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateShareIssueBoardMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createShareIssueBoardMemberMutation, { data, loading, error }] = useCreateShareIssueBoardMemberMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateShareIssueBoardMemberMutation(baseOptions?: Apollo.MutationHookOptions<GqlCreateShareIssueBoardMemberMutation, GqlCreateShareIssueBoardMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreateShareIssueBoardMemberMutation, GqlCreateShareIssueBoardMemberMutationVariables>(CreateShareIssueBoardMemberDocument, options);
      }
export type CreateShareIssueBoardMemberMutationHookResult = ReturnType<typeof useCreateShareIssueBoardMemberMutation>;
export type CreateShareIssueBoardMemberMutationResult = Apollo.MutationResult<GqlCreateShareIssueBoardMemberMutation>;
export type CreateShareIssueBoardMemberMutationOptions = Apollo.BaseMutationOptions<GqlCreateShareIssueBoardMemberMutation, GqlCreateShareIssueBoardMemberMutationVariables>;
export const DeleteShareIssueBoardMemberDocument = gql`
    mutation DeleteShareIssueBoardMember($companyId: ID!, $id: ID!) {
  deleteShareIssueBoardMember(companyId: $companyId, id: $id) {
    id
  }
}
    `;
export type GqlDeleteShareIssueBoardMemberMutationFn = Apollo.MutationFunction<GqlDeleteShareIssueBoardMemberMutation, GqlDeleteShareIssueBoardMemberMutationVariables>;

/**
 * __useDeleteShareIssueBoardMemberMutation__
 *
 * To run a mutation, you first call `useDeleteShareIssueBoardMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteShareIssueBoardMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteShareIssueBoardMemberMutation, { data, loading, error }] = useDeleteShareIssueBoardMemberMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteShareIssueBoardMemberMutation(baseOptions?: Apollo.MutationHookOptions<GqlDeleteShareIssueBoardMemberMutation, GqlDeleteShareIssueBoardMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlDeleteShareIssueBoardMemberMutation, GqlDeleteShareIssueBoardMemberMutationVariables>(DeleteShareIssueBoardMemberDocument, options);
      }
export type DeleteShareIssueBoardMemberMutationHookResult = ReturnType<typeof useDeleteShareIssueBoardMemberMutation>;
export type DeleteShareIssueBoardMemberMutationResult = Apollo.MutationResult<GqlDeleteShareIssueBoardMemberMutation>;
export type DeleteShareIssueBoardMemberMutationOptions = Apollo.BaseMutationOptions<GqlDeleteShareIssueBoardMemberMutation, GqlDeleteShareIssueBoardMemberMutationVariables>;
export const SiSetBoardsStatementDocument = gql`
    mutation SiSetBoardsStatement($companyId: ID!, $input: SiSetBoardsStatementInput!) {
  siSetBoardStatement(companyId: $companyId, input: $input) {
    shareIssue {
      ...SiFields
    }
  }
}
    ${SiFieldsFragmentDoc}`;
export type GqlSiSetBoardsStatementMutationFn = Apollo.MutationFunction<GqlSiSetBoardsStatementMutation, GqlSiSetBoardsStatementMutationVariables>;

/**
 * __useSiSetBoardsStatementMutation__
 *
 * To run a mutation, you first call `useSiSetBoardsStatementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSiSetBoardsStatementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [siSetBoardsStatementMutation, { data, loading, error }] = useSiSetBoardsStatementMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSiSetBoardsStatementMutation(baseOptions?: Apollo.MutationHookOptions<GqlSiSetBoardsStatementMutation, GqlSiSetBoardsStatementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlSiSetBoardsStatementMutation, GqlSiSetBoardsStatementMutationVariables>(SiSetBoardsStatementDocument, options);
      }
export type SiSetBoardsStatementMutationHookResult = ReturnType<typeof useSiSetBoardsStatementMutation>;
export type SiSetBoardsStatementMutationResult = Apollo.MutationResult<GqlSiSetBoardsStatementMutation>;
export type SiSetBoardsStatementMutationOptions = Apollo.BaseMutationOptions<GqlSiSetBoardsStatementMutation, GqlSiSetBoardsStatementMutationVariables>;